module.exports = __webpack_public_path__ + "img/246.20da6153.jpg";